<template>
    <spinner v-if="isLoading"></spinner>
    <transition name="fade">
        <div>
            <BreadCrumbs
                :breadCrumbs="breadCrumbs"
                :title="title"
                :back_title="back_title"
                :link="link"
            />
            <div class="page">
                <div class="row">
                    <h2 class="mb-4">Чек-лист TSM</h2>
                    <div class="control_row hstack gap-3 mb-4 flex-wrap">
                        <div class="control_row_cell col-12 col-md-8 col-lg-6 col-xl-5">
                            <VueMultiselect
                                v-model="item"
                                placeholder="Выберите отдел"
                                label="name"
                                track-by="id"
                                :options="optionsItem"
                                :show-labels="false"
                                @tag="addItem"></VueMultiselect>
                        </div>
                        <div class="control_row_cell ms-auto col-12 col-md-3 col-xl-2">
                            <router-link to="/tsm-setting/create"
                                v-if="contains(actions, 'dobavit-vopros-v-cek-list-tsm')"
                            >
                                <button class="btn gray btn_add w-100">Добавить</button>
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="table-responsive-md">
                    <table class="table table-row table-app">
                        <thead>
                            <tr>
                                <th class="text-muted">Отдел</th>
                                <th class="text-muted">Название</th>
                                <th class="text-muted">Срок</th>
                                <th style="width: 20%;" class="text-muted">Ответственные</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="checklist in filteredDepartment" :key="checklist.id">
                                <td>
                                    {{ checklist.item.name }}
                                </td>
                                <td>
                                    {{ checklist.name }}
                                </td>
                                <td>
                                    {{ checklist.deadline.time_performance }}
                                </td>
                                <td>
                                    <div v-for="item in checklist.user">
                                        <div>{{ item.surname }}
                                            {{ item.name }}</div>
                                    </div>
                                </td>
                                <td class="text-end" style="width: 5%;"
                                    v-if="contains(actions, 'redaktirovat-vopros-cek-lista-tsm') || contains(actions, 'udalit-vopros-cek-lista-tsm')"
                                >
                                    <div class="dropdown">
                                        <button
                                            class="btn btn_drop px-0"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            id="dropdownMenuButton">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="#ccc"
                                                class="bi bi-three-dots-vertical"
                                                viewBox="0 0 16 16">
                                                <path
                                                    d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                            </svg>
                                        </button>
                                            <ul
                                                class="dropdown-menu dropdown-menu-end"
                                                aria-labelledby="dropdownMenuButton">
                                                <li
                                                    v-if="contains(actions, 'redaktirovat-vopros-cek-lista-tsm')"
                                                >
                                                    <button
                                                        type="button"
                                                        @click="$router.push(`/tsm-setting/edit/${checklist.id}`)"
                                                        class="dropdown-item">Редактировать</button>
                                                </li>
                                                <li><hr class="dropdown-divider"></li>
                                                <li
                                                    v-if="contains(actions, 'udalit-vopros-cek-lista-tsm')"
                                                >
                                                    <button type="button" @click="deleteItem(checklist.id)" class="dropdown-item">Удалить</button>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </transition>
    </template>

<script>
import axios from "axios";
import spinner from '../../../components/Spinner';
import {ErrorMessage, Field, Form} from "vee-validate";
import VueMultiselect from "vue-multiselect";
import BreadCrumbs from "../../../Page/BreadCrumbs";
import {getUserPermissionActions} from "../../../services/helpers";

export default {
    name: "TSMIndexCheck",
    components: {
        spinner, Field, Form, ErrorMessage, VueMultiselect, BreadCrumbs
    },
    data(){
        return {
            item: null,
            checklists: [],
            actions: [],
            isLoading: false,
            optionsItem: [],
            breadCrumbs: true,
            title: 'Чек листы TSM',
            back_title: 'Настройки чек листов',
            link: 'check-setting',
        }
    },
    computed: {
        filteredDepartment: function() {
            return this.checklists.filter(function(check) {
                if(this.item !== null){
                    return check.item_id == this.item.id;
                }else{
                    return this.checklists;
                }
            }.bind(this));
        },
    },
    created() {
        this.getCheckLists();
        this.getUserActions();
    },
    methods: {
        async getUserActions(){
            this.isLoading = true;
            this.actions = await getUserPermissionActions('/check-setting');
            this.isLoading = false;
        },
        contains(arr, elem){
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].alias === elem) {
                    return true;
                }
            }
            return false;
        },
        deleteItem(id){
            const config = {'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') }};
            axios.delete(`/api/admin/tsm/${id}`, config)
                .then(response =>{
                    if(response.status == 200){
                        /* this.$flashMessage.show({
                             type: 'success',
                             text: 'Пункт меню успешно удален!',
                         });*/
                        this.getCheckLists();
                    }
                })
                .catch(error =>{
                    console.log(error);
                });
        },
        async getCheckLists(){
            try {
                this.isLoading = true;
                const config = {'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') }};
                const response = await axios.get('/api/admin/tsm', config);
                this.checklists = response.data.data.checklists;
                this.optionsItem = response.data.data.items;
            } catch (e) {
                console.log(e);
            }finally {
                this.isLoading = false;
            }
        },
        addItem(newItem){
            const item = {
                name: newItem,
            }
            this.optionsItem.push(item)
            this.item.push(item)
        },
    }
}
</script>

<style scoped>

</style>
